export const reasons = [
    {
        reason: "Experienced and Professional Team"
    },
    {
        reason: "Comprehensive Services"
    },
    {
        reason: "User-Friendly Interface"
    },
    {
        reason: "Safe and Secure Data Storage"
    },
    {
        reason: "Personalized Care"
    },
    {
        reason: "Positive Reputation"
    },
    {
        reason: "Convenient Access to Healthcare Services."
    }
];